import { type CustomerState } from '../../customer/customerSlice'
import { FlatBOM, type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'
import type * as DynamakerContract from '../../../integration/DynamakerContract'

const axios = axiosInstance()

interface Response {
  yassConfigId: string
  yassConfigHashKey: string
}

export const postSaveconfig = async <T = any>(args: {
  apiConfigs: APIConfig
  data: {
    config: DynamakerContract.ProjectData['config']
    bom: FlatBOM
    configurationSections: DynamakerContract.BOM
    meta: DynamakerContract.Metadata
    bundle: any
    customer: CustomerState
    yass: {
      configId: string
      configHashKey: string
    }
    type: any
  }
  onSuccess: (response: { data: Response }) => T
}): Promise<T> => {
  const { onSuccess } = args
  const { marketCode, languageCode, configstoreApiBaseUrl } = args.apiConfigs
  const { configId: yassConfigId, configHashKey: yassConfigHashKey } = args.data.yass
  const {
    bom: dmBom,
    configurationSections: dmConfigurationSections,
    bundle: priceInfo,
    config: dmConfigData,
    customer,
    meta: dmMetadata,
    type,
  } = args.data

  return await axios<Response>({
    method: 'post',
    url: `${configstoreApiBaseUrl}/saveconfig`,
    data: {
      schemaVersion: 1,
      originReferal:
        yassConfigId && yassConfigHashKey
          ? {
              yassConfigId,
              yassConfigHashKey,
            }
          : null,
      dmConfigData,
      dmBom,
      dmConfigurationSections,
      dmMetadata,
      priceInfo,
      type,
      marketCode,
      languageCode,
      customer: {
        name: customer.name || null,
        adress: customer.adress || null,
        zipCode: customer.zipCode || null,
        city: customer.city || null,
        country: 'SE',
        erpCusNo: customer.erpCusNo || null,
        cnohash: customer.cnohash || null,
        email: customer.email || null,
        phone: customer.phone || null,
        marketingOptIn: customer.marketingOptIn, // can be null, indicates 'intentionally omitted' to backend
      },
    },
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
